import "./styles/app.css";
import Routing from "./Routes/Routing";
import { DesignProvider } from "./context/DesignContext";
import { BrowserRouter, useLocation } from "react-router-dom";
import { lazy, Suspense, useEffect, useState } from "react";
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary";
import { useAuth } from "./hooks/useAuth";


// ✅ ProductFruits Configuration
// To change the ProductFruits account, update the workspace code below
const PRODUCTFRUITS_WORKSPACE_CODE = "md7a2flqHcsHXnfz";

const ProductFruitsLazy = lazy(() =>
  import("react-product-fruits")
    .then((m) => ({ default: m.ProductFruits }))
    .catch((error) => {
      console.warn("Failed to load ProductFruits:", error);
      // Return a no-op component instead of failing
      return { default: () => null };
    })
);
if (!Object.hasOwn) {
  Object.hasOwn = (obj, prop) =>
    Object.prototype.hasOwnProperty.call(obj, prop);
}

if (!Array.prototype.at)
  Array.prototype.at = function (n) {
    return n < 0 ? this[this.length + n] : this[n];
  };



function App() {
  const { user, isAdmin, isMember } = useAuth();
  const memberRaw = localStorage.getItem("member");
  let loginMemberData = undefined;
  if (memberRaw) {
    loginMemberData = JSON.parse(memberRaw);
  }
  const [showPF, setShowPF] = useState(false);

  useEffect(() => {
    if (
      (window as any).__BROWSABLE_LIGHT_SHELL__ ||
      /^\/website(\/|$)/.test(window.location.pathname || "")
    ) {
      return;
    }
    // ✅ Fixed: Load ProductFruits earlier to ensure announcements work
    // Announcements need to initialize early to match URLs and user context
    if ((window as any).requestIdleCallback) {
      (window as any).requestIdleCallback(() => setShowPF(true), { timeout: 200 });
    } else {
      // Fallback: load after a short delay to not block initial render
      setTimeout(() => setShowPF(true), 100);
    }
   
  }, []);


  // ProductFruits requires a non-empty `username` field as a unique identifier.
  // During onboarding / first dashboard load, `user_metadata.username` can be missing briefly.
  // Fall back to Supabase Auth user id (stable) then email.
  const pfUsername =
    user?.user_metadata?.username ||
    loginMemberData?.username ||
    user?.id ||
    user?.email ||
    loginMemberData?.email ||
    "";

  const userInfo = {
    username: pfUsername, // REQUIRED - any unique user identifier (must be non-empty)
    email: user?.email || loginMemberData?.email || "",
    firstname: user?.user_metadata?.name?.split(" ")[0] || "",
    lastname: user?.user_metadata?.name?.split(" ")[1] || "",
    signupAt: user?.created_at, // ✅ Fixed: lowercase 'u' and ISO 8601 format with time
    role: user?.user_metadata?.role || "manager",
    props: {
      customProp1: "==REPLACE==",
      // ✅ ProductFruits reads custom properties from props object
      // Handle both boolean true and string "true" from database
      is_first_login: (user?.user_metadata?.is_first_login === true || user?.user_metadata?.is_first_login === "true") ,
      isAdmin: isAdmin ? true : false,
      isMember: isMember ? true : false,
    },
  };
  // const userInfo = user;

  return (
    <DesignProvider>
      {/* <ErrorBoundary> */}
        <div className="App fullDiv">
          {/* ✅ Fixed: ProductFruits needs to be rendered early for announcements/banners
            Announcements are matched by URL and user context, so they need to initialize
            as soon as possible after the app loads */}

          {/* Disable ProductFruits announcements/tours in admin mode */}
          {showPF && Boolean(pfUsername) && (
            <ErrorBoundary
              fallback={null}
              onError={(error) => {
                console.warn("ProductFruits error (non-critical):", error);
                // Log to help debug announcement issues
                console.warn("ProductFruits workspace:", PRODUCTFRUITS_WORKSPACE_CODE);
              }}
            >
              <Suspense fallback={null}>
                <ProductFruitsLazy
                  workspaceCode={PRODUCTFRUITS_WORKSPACE_CODE}
                  language="en"
                  user={userInfo}
                // ✅ Added: Ensure announcements are enabled (default is true, but explicit is better)
                // ProductFruits will automatically show announcements/banners if configured in the portal
                />
              </Suspense>
            </ErrorBoundary>
          )}

          <BrowserRouter>
            <ErrorBoundary>
              {/* Auto-resize iframe height for embeds on route/search changes */}
              <Routing />
            </ErrorBoundary>
          </BrowserRouter>
        </div>
      {/* </ErrorBoundary> */}
    </DesignProvider>
  );
}

export default App;
